import React from "react";
import Button from "../button/button";
import SimplePopup from "../popup/simplePopup";
import imgFra from "./assets/fr.png"
import imgEng from "./assets/en.png"


import { getCurrentLanguage, setCurrentLanguage } from "../../../utils/software";

class SelectLanguage extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            currentlanguage :getCurrentLanguage(),
            displaypopup:false,
        }

        this.newlanguage = "fr";
        this.onclickenglish = this.onclickenglish.bind(this);
        this.onclickfrench = this.onclickfrench.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onDontChange = this.onDontChange.bind(this)
    }
    componentDidMount()
    {

    }

    onChange()
    {
        setCurrentLanguage(this.newlanguage);
        window.location.reload();
    }

    onDontChange()
    {
        this.setState({displaypopup:false})
    }



    onclickenglish()
    {   
        this.newlanguage = "en";
        if (!this.props.popup)
            {
                this.onChange();
                return;
            }
        this.setState({displaypopup: true})

    }

    onclickfrench()
    {
        this.newlanguage = "fr";
        if (!this.props.popup)
        {
            this.onChange();
            return;
        }
        this.setState({displaypopup: true})
    }

    
    
    render()
    {

        const big=25;
        var small=18;
        if (this.props.horizontal) small=30;

        const frenchbutton = 
        (
            <Button button={true} image={imgFra}
                width = {this.state.currentlanguage==="fr"?big:small}
                height = {this.state.currentlanguage==="fr"?big:small}
                onClick = {this.onclickfrench}
                nochangecolor = {true}
                tooltip = {{fr:"Français",en:"French"}}
                
            />
        )

        const englishbouton = 
        (
            <Button button={true} image={imgEng}
                width = {this.state.currentlanguage==="en"?big:small}
                height = {this.state.currentlanguage==="en"?big:small}
                onClick = {this.onclickenglish}
                nochangecolor = {true}
                tooltip = {{fr:"Anglais",en:"English"}}
                
            />
        )


        var boutons = 
        (        
        <table style={{"marginTop":"4px"}}>
            
            <tr>
                <td>
                    {frenchbutton}
                </td>
            </tr>
            <tr>
                <td>
                    {englishbouton}
                </td>
            </tr>
        </table>
        )

        if (this.props.horizontal)
        {
            boutons = 
            (
                <>{frenchbutton}&nbsp;{englishbouton}&nbsp;&nbsp;</>
            )
        }

        return (

            <>
            <SimplePopup 
                display={this.state.displaypopup} 
                title={{fr:"Changer la langue",en:"Change language."}}
                text={{
                    fr: "L'application doit être relancée pour appliquer le changement. Confirmez vous ?",
                    en: "The application must be restarted to apply the change. Do you confirm?",
                }} 

                onCancel={this.onDontChange}
                buttons ={
                    [
                        {text:{"fr":"Oui","en":"Ok"},onclick:this.onChange},
                        {text:{"fr":"Non","en":"Cancel"},onclick:this.onDontChange},
                    ]} />

             {boutons}
        </>
        )


    }


}

SelectLanguage.defaultProps = 
{
    popup: true,
    horizontal: false,
}
export default SelectLanguage